import SessionStorageAdapter from 'shared/sessionstorage_adapter.js';

export default class FontLoader {
  static run() {
    if (!SessionStorageAdapter.getItem('fonts-loaded')) {
      this.loadFontFaceObserver();
    }
  }

  static loadFontFaceObserver() {
    let FontFaceObserver = require('fontfaceobserver');
    let font = new FontFaceObserver('proxima_nova', {
      weight: 400
    });

    font.load().then(function () {
      document.documentElement.className += " fonts-loaded";
      SessionStorageAdapter.setItem('fonts-loaded', 1);
    });
  }
}
